import { GameType } from '@shared/types/game-type';
import { BOARD_MENU_ITEMS } from './menu-items/board.menu-items';
import { HUB_MENU_ITEMS } from './menu-items/hub.menu-items';
import { JACKPOT_MENU_ITEMS } from './menu-items/jackpot.menu-items';
import { MULTI_WHEEL_MENU_ITEMS } from './menu-items/multi-wheel.menu-items';
import { QUIZ_MENU_ITEMS } from './menu-items/quiz.menu-items';
import { SPIN_MACHINE_MENU_ITEMS } from './menu-items/spin-machine.menu-items';
import { WHEEL_MENU_ITEMS } from './menu-items/wheel.menu-items';
import { STREAKS_MENU_ITEMS } from './menu-items/streaks.menu-item';

export { DIVIDER_NAME } from './menu-items/menu-item.type';
export type { MenuItem } from './menu-items/menu-item.type';
import type { MenuItem } from './menu-items/menu-item.type';

export const MENU_ITEMS_BY_TYPE: Record<GameType, MenuItem[]> = {
  [GameType.SPIN_MACHINE]: SPIN_MACHINE_MENU_ITEMS,
  [GameType.QUIZ]: QUIZ_MENU_ITEMS,
  [GameType.JACKPOT]: JACKPOT_MENU_ITEMS,
  [GameType.WHEEL]: WHEEL_MENU_ITEMS,
  [GameType.MULTI_WHEEL]: MULTI_WHEEL_MENU_ITEMS,
  [GameType.HUB]: HUB_MENU_ITEMS,
  [GameType.BOARD]: BOARD_MENU_ITEMS,
  [GameType.STREAKS]: STREAKS_MENU_ITEMS,
};
